// @ts-nocheck

import { ButtonBack } from 'components/buttonBack/buttonBack'
import * as S from './ShowRequest.styles'
import { Button, Heading, Paragraph } from 'applaus-ui-kit'
import { useDispatch, useSelector } from 'react-redux'
import { ReduxState } from 'redux/rootReducer'
import { motion } from 'framer-motion'
import moment from 'moment'
import { formatPrice } from 'utils/formatPrice'
import { BrandCreditCard } from 'components/brandCreditCard/BrandCreditCard'
import history from 'routes/services/history'
import { useParams } from 'react-router-dom'
import { downloadPurchasePDF } from 'api/services/purchases/downloadPurchasePDF'
import { isReceivedTransferOrder } from 'utils/isReceivedTransferOrder'
import { useMemo, useState } from 'react'
import { getPurchaseOrderByIdRequestAction } from 'redux/Purchases/actions'
import { TransferTicketModal } from 'components/TransferTicketModal/TransferTicketModal'
import { CancelTransferActions } from 'components/CancelTransferActions/CancelTransferActions'

export const ShowRequest = () => {
  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()

  const { selectedPurchaseOrder } = useSelector(
    (state: ReduxState) => state.PurchasesReducer
  )
  const isReceived = isReceivedTransferOrder(selectedPurchaseOrder)
  const receivedAt = moment(
    selectedPurchaseOrder?.updatedAt || selectedPurchaseOrder?.createdAt
  )
  const [isTransferModalOpen, setIsTransferModalOpen] = useState(false)

  const hasTransferableTickets = useMemo(() => {
    return (selectedPurchaseOrder?.customerTickets ?? []).some((ticket) => {
      if (ticket.detachedAt) return false
      if (ticket.isValid === false) return false
      if (ticket.status && ticket.status !== 'ACTIVE') return false
      return true
    })
  }, [selectedPurchaseOrder])

  const refreshPurchaseOrder = () => {
    dispatch(getPurchaseOrderByIdRequestAction(id))
  }

  const handleTransferModalClose = () => {
    setIsTransferModalOpen(false)
    refreshPurchaseOrder()
  }

  return (
    <motion.div animate={{ opacity: [0, 1], transition: { duration: 0.5 } }}>
      <S.Container>
        <ButtonBack
          title={
            'Pedido: ' + selectedPurchaseOrder?.orderId.toLocaleUpperCase()
          }
          subTitle={
            (isReceived ? 'Recebido em ' : 'Comprado em ') +
            receivedAt.format('DD/MM/YYYY') +
            ' às ' +
            receivedAt.format('LT')
          }
          click={() => history.push('/purchases')}
        />

        <S.Wrapper>
          <S.CoverUrl
            src={selectedPurchaseOrder?.eventItem.event.banners.mobileUrl}
            alt=""
          />

          <S.PaymentStatus>
            <S.TextStatus status={selectedPurchaseOrder!.status}>
              {isReceived ? (
                <>
                  Status: <p className="approvedText">Recebido</p>
                </>
              ) : (
                <>
                  Pagamento:{' '}
                  <p className="approvedText">
                    {selectedPurchaseOrder?.status === 'WAITING'
                      ? 'EM ANÁLISE'
                      : 'APROVADO'}
                  </p>
                </>
              )}
            </S.TextStatus>

            <S.PaymentData>
              {isReceived ? 'Recebido em ' : 'Realizado em '}
              {receivedAt.format('DD/MM/YYYY') +
                ' às ' +
                receivedAt.format('LT')}
            </S.PaymentData>
          </S.PaymentStatus>

          {!isReceived ? (
            <>
              {selectedPurchaseOrder?.payment.cashBackDiscountCents === null ||
              selectedPurchaseOrder?.payment.cashBackDiscountCents === 0 ? (
                <S.PaymentValue>
                  <S.TextValue>
                    {formatPrice(
                      selectedPurchaseOrder!.payment.totalPrice / 100
                    )}{' '}
                    {selectedPurchaseOrder?.payment.installments ===
                      undefined ||
                    selectedPurchaseOrder?.payment.installments === null
                      ? 'à vista'
                      : `${selectedPurchaseOrder?.payment.installments}x`}
                  </S.TextValue>
                  <BrandCreditCard
                    brandIcon={
                      selectedPurchaseOrder!.payment.paymentMethod === 'PIX'
                        ? selectedPurchaseOrder!.payment.paymentMethod
                        : selectedPurchaseOrder!.payment.brand
                    }
                    brand={
                      selectedPurchaseOrder!.payment.paymentMethod === 'PIX'
                        ? ''
                        : selectedPurchaseOrder!.payment.brand
                    }
                    paymentMethod={selectedPurchaseOrder!.payment.paymentMethod}
                    lastNumbers={selectedPurchaseOrder!.payment.lastCardNumbers}
                    final
                  />
                </S.PaymentValue>
              ) : (
                <div style={{ marginTop: '16px' }} />
              )}

              {selectedPurchaseOrder?.payment.cashBackDiscountCents !== null &&
              selectedPurchaseOrder?.payment.cashBackDiscountCents! > 0 ? (
                <S.CashBackPaid>
                  <div className="cashbackBox">
                    <Paragraph variant="small" className="bold">
                      {formatPrice(
                        selectedPurchaseOrder?.payment.cashBackDiscountCents! /
                          100
                      )}
                    </Paragraph>

                    <div>
                      <S.IconCashback />
                      <Paragraph variant="small">Cashback</Paragraph>
                    </div>
                  </div>
                  <div className="paymentBox">
                    <Paragraph variant="small" className="bold">
                      {formatPrice(
                        (selectedPurchaseOrder?.payment.totalPrice! -
                          selectedPurchaseOrder?.payment
                            .cashBackDiscountCents!) /
                          100
                      )}
                    </Paragraph>

                    <div>
                      <BrandCreditCard
                        brandIcon={
                          selectedPurchaseOrder!.payment.paymentMethod === 'PIX'
                            ? selectedPurchaseOrder!.payment.paymentMethod
                            : selectedPurchaseOrder!.payment.brand
                        }
                        brand={
                          selectedPurchaseOrder!.payment.paymentMethod === 'PIX'
                            ? selectedPurchaseOrder!.payment.brand
                            : selectedPurchaseOrder!.payment.brand
                        }
                        paymentMethod={
                          selectedPurchaseOrder!.payment.paymentMethod
                        }
                        lastNumbers={
                          selectedPurchaseOrder!.payment.lastCardNumbers
                        }
                        final
                      />
                    </div>
                  </div>

                  <div className="divider" />

                  <Heading variant="h3">
                    Total:{' '}
                    {formatPrice(
                      selectedPurchaseOrder?.payment.totalPrice! / 100
                    )}
                  </Heading>
                </S.CashBackPaid>
              ) : null}

              {selectedPurchaseOrder?.eventItem.event.cashBackPercent !==
                null &&
              selectedPurchaseOrder?.eventItem.event.cashBackPercent! > 0 ? (
                <S.CashBackReceived>
                  <Paragraph variant="large" className="textCashback">
                    Você ganhou!
                  </Paragraph>
                  <Paragraph variant="regular">
                    {formatPrice(
                      (selectedPurchaseOrder?.eventItem.event.cashBackPercent! *
                        selectedPurchaseOrder?.payment.totalPrice!) /
                        10000
                    )}{' '}
                    de cashback com essa compra
                  </Paragraph>
                </S.CashBackReceived>
              ) : null}
            </>
          ) : (
            <div style={{ marginTop: '16px' }} />
          )}

          {selectedPurchaseOrder?.status === 'SUCCESS' ? (
            <>
              <Button
                fullWidth
                variant="contained"
                size="small"
                color="primary"
                onClick={() => history.push(`/tickets/${id}`)}>
                Ver ingressos
              </Button>
              <S.DownloadButton onClick={() => downloadPurchasePDF(id)}>
                Baixar ingresso <S.DownloadIcon />
              </S.DownloadButton>
              {hasTransferableTickets ? (
                <S.DownloadButton onClick={() => setIsTransferModalOpen(true)}>
                  Transferir ingresso
                </S.DownloadButton>
              ) : null}
              <CancelTransferActions
                purchaseOrderId={id}
                tickets={selectedPurchaseOrder?.customerTickets ?? []}
                ButtonComponent={S.CancelTransferButton}
                ErrorComponent={S.CancelError}
              />
            </>
          ) : null}
        </S.Wrapper>
      </S.Container>
      <TransferTicketModal
        isOpen={isTransferModalOpen}
        handleClose={handleTransferModalClose}
        onSuccess={refreshPurchaseOrder}
        purchaseOrder={selectedPurchaseOrder}
      />
    </motion.div>
  )
}
